{
  "about.blocks": "Модеровані сервери",
  "about.contact": "Контакти:",
  "about.default_locale": "За замовчуванням",
  "about.domain_blocks.no_reason_available": "Причина недоступна",
  "about.domain_blocks.preamble": "Mastodon зазвичай дозволяє вам взаємодіяти з користувачами будь-яких серверів у Федіверсі та переглядати їх вміст. Ось винятки, які було зроблено на цьому конкретному сервері.",
  "about.domain_blocks.silenced.explanation": "Ви загалом не будете бачити профілі та вміст цього сервера, якщо ви не шукаєте їх цілеспрямовано або не підписані на його користувачів.",
  "about.domain_blocks.silenced.title": "Обмежені",
  "about.domain_blocks.suspended.explanation": "Дані з цього сервера не будуть оброблятися, зберігатися чи обмінюватися, що унеможливить взаємодію чи спілкування з користувачами цього сервера.",
  "about.domain_blocks.suspended.title": "Заблоковані",
  "about.language_label": "Мова",
  "about.not_available": "Ця інформація не доступна на цьому сервері.",
  "about.powered_by": "Децентралізовані соціальні мережі від {mastodon}",
  "about.rules": "Правила сервера",
  "account.account_note_header": "Особиста нотатка",
  "account.activity": "Дії",
  "account.add_note": "Додати особисту нотатку",
  "account.add_or_remove_from_list": "Додати або видалити зі списків",
  "account.badges.admin": "Адміністрація",
  "account.badges.blocked": "Заблоковано",
  "account.badges.bot": "Бот",
  "account.badges.domain_blocked": "Блокований домен",
  "account.badges.group": "Група",
  "account.block": "Заблокувати @{name}",
  "account.block_domain": "Заблокувати домен {domain}",
  "account.block_short": "Заблокувати",
  "account.blocked": "Заблоковані",
  "account.cancel_follow_request": "Відкликати запит на стеження",
  "account.copy": "Копіювати посилання на профіль",
  "account.direct": "Особиста згадка @{name}",
  "account.disable_notifications": "Не повідомляти мене про дописи @{name}",
  "account.edit_note": "Редагувати особисту нотатку",
  "account.edit_profile": "Редагувати профіль",
  "account.edit_profile_short": "Редагувати",
  "account.enable_notifications": "Повідомляти мене про дописи @{name}",
  "account.endorse": "Рекомендувати у моєму профілі",
  "account.familiar_followers_many": "Має серед підисників {name1}, {name2} та ще {othersCount, plural, one {# відомого вам користувача} few {# відомих вам користувачів} many {# відомих вам користувачів} other {# відомих вам користувачів}}",
  "account.familiar_followers_one": "Має серед підписників {name1}",
  "account.familiar_followers_two": "Має серед підписників {name1} та {name2}",
  "account.featured": "Рекомендоване",
  "account.featured.accounts": "Профілі",
  "account.field_overflow": "Показати повністю",
  "account.filters.all": "Усі дії",
  "account.filters.boosts_toggle": "Показати поширення",
  "account.filters.posts_boosts": "Дописи й поширення",
  "account.filters.posts_only": "Дописи",
  "account.filters.posts_replies": "Дописи й відповіді",
  "account.filters.replies_toggle": "Показати відповіді",
  "account.follow": "Підписатися",
  "account.follow_back": "Стежити також",
  "account.follow_back_short": "Підписатись навзаєм",
  "account.follow_request": "Запит на підписку",
  "account.follow_request_cancel": "Скасувати запит",
  "account.follow_request_cancel_short": "Скасувати",
  "account.follow_request_short": "Запит",
  "account.followers": "Підписники",
  "account.followers.empty": "Ніхто ще не підписаний на цього користувача.",
  "account.followers_counter": "{count, plural, one {{counter} підписник} few {{counter} підписники} many {{counter} підписників} other {{counter} підписник}}",
  "account.followers_you_know_counter": "{count, plural, one {{counter} відомий вам} few {{counter} відомі вам} many {{counter} відомих вам} other {{counter} відомі вам}}",
  "account.following": "Підписки",
  "account.following_counter": "{count, plural, one {{counter} підписка} few {{counter} підписки} many {{counter} підписок} other {{counter} підписка}}",
  "account.follows.empty": "Цей користувач ще ні на кого не підписався.",
  "account.follows_you": "Підписаний(-а) на вас",
  "account.go_to_profile": "Перейти до профілю",
  "account.hide_reblogs": "Сховати поширення від @{name}",
  "account.in_memoriam": "Пам'ятник.",
  "account.joined_short": "Дата приєднання",
  "account.languages": "Змінити обрані мови",
  "account.link_verified_on": "Права власності на це посилання були перевірені {date}",
  "account.locked_info": "Це закритий обліковий запис. Власник вручну обирає, хто може на нього підписуватися.",
  "account.media": "Медіа",
  "account.mention": "Згадати @{name}",
  "account.menu.add_to_list": "Додати до списку…",
  "account.menu.block": "Блокувати обліковий запис",
  "account.menu.block_domain": "Блокувати {domain}",
  "account.menu.copied": "Посилання на обліковий запис скопійовано до буферу обміну",
  "account.menu.copy": "Копіювати посилання",
  "account.menu.direct": "Особиста згадка",
  "account.menu.mention": "Згадка",
  "account.menu.note.description": "Видно лише вам",
  "account.menu.open_original_page": "Переглянути на {domain}",
  "account.menu.remove_follower": "Вилучити підписника",
  "account.menu.report": "Скарга на обліковий запис",
  "account.menu.share": "Поділитися…",
  "account.menu.unblock": "Розблокувати обліковий запис",
  "account.menu.unblock_domain": "Розблокувати {domain}",
  "account.moved_to": "{name} вказує, що їхній новий обліковий запис тепер:",
  "account.mute": "Приховати @{name}",
  "account.mute_notifications_short": "Не сповіщати",
  "account.mute_short": "Ігнорувати",
  "account.muted": "Приховується",
  "account.mutual": "Підписані навзаєм",
  "account.no_bio": "Немає опису.",
  "account.node_modal.save": "Зберегти",
  "account.open_original_page": "Відкрити оригінальну сторінку",
  "account.posts": "Дописи",
  "account.remove_from_followers": "Вилучити {name} із підписників",
  "account.report": "Поскаржитися на @{name}",
  "account.requested_follow": "{name} надсилає запит на стеження",
  "account.share": "Поділитися профілем @{name}",
  "account.show_reblogs": "Показати поширення від @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} допис} few {{counter} дописи} many {{counter} дописів} other {{counter} допис}}",
  "account.unblock": "Розблокувати @{name}",
  "account.unblock_domain": "Розблокувати {domain}",
  "account.unblock_domain_short": "Розблокувати",
  "account.unblock_short": "Розблокувати",
  "account.unendorse": "Не публікувати у профілі",
  "account.unfollow": "Відписатися",
  "account.unmute": "Не приховувати @{name}",
  "account.unmute_notifications_short": "Сповіщати",
  "account.unmute_short": "Не приховувати",
  "account_edit.save": "Зберегти",
  "account_edit_tags.suggestions": "Пропозиції:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# допис} few {# дописи} many {# дописів} other {# допису}}",
  "admin.dashboard.daily_retention": "Щоденний показник утримання користувачів після реєстрації",
  "admin.dashboard.monthly_retention": "Щомісячний показник утримання користувачів після реєстрації",
  "admin.dashboard.retention.average": "Середнє",
  "admin.dashboard.retention.cohort": "Місяць реєстрації",
  "admin.dashboard.retention.cohort_size": "Нові користувачі",
  "admin.impact_report.instance_accounts": "Профілі облікових записів буде видалено",
  "admin.impact_report.instance_followers": "Підписники, яких можуть втратити наші користувачі",
  "admin.impact_report.instance_follows": "Підписники, яких можуть втратити їхні користувачі",
  "admin.impact_report.title": "Підсумки впливу",
  "alert.rate_limited.message": "Спробуйте ще раз за {retry_time, time, medium}.",
  "alert.rate_limited.title": "Швидкість обмежена",
  "alert.unexpected.message": "Сталася неочікувана помилка.",
  "alert.unexpected.title": "Ой!",
  "alt_text_badge.title": "Альтернативний текст",
  "alt_text_modal.add_alt_text": "Додати альтернативний текст",
  "alt_text_modal.add_text_from_image": "Додати текст із малюнку",
  "alt_text_modal.cancel": "Скасувати",
  "alt_text_modal.change_thumbnail": "Змінити мініатюру",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Опишіть цю ідею для людей із порушеннями слуху…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Опишіть цю ідею для людей із порушеннями зору…",
  "alt_text_modal.done": "Готово",
  "announcement.announcement": "Оголошення",
  "annual_report.announcement.action_dismiss": "Ні, дякую",
  "annual_report.nav_item.badge": "Нове",
  "annual_report.shared_page.donate": "Підтримати",
  "annual_report.summary.archetype.booster.name": "Лучник",
  "annual_report.summary.archetype.lurker.name": "Стоїк",
  "annual_report.summary.archetype.oracle.name": "Провидець",
  "annual_report.summary.archetype.pollster.name": "Допитливий",
  "annual_report.summary.archetype.replier.name": "Метелик",
  "annual_report.summary.archetype.title_public": "Архетип {name}",
  "annual_report.summary.archetype.title_self": "Ваш архетип",
  "annual_report.summary.close": "Закрити",
  "annual_report.summary.copy_link": "Копіювати посилання",
  "annual_report.summary.followers.new_followers": "{count, plural, one {новий підписник} few {нові підписники} many {нових підписників} other {нового підписника}}",
  "annual_report.summary.highlighted_post.boost_count": "Допис поширено {count, plural, one {# раз} few {# рази} many {# разів} other {# раза}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Допис уподобано {count, plural, one {# раз} few {# рази} many {# разів} other {# раза}}.",
  "annual_report.summary.highlighted_post.reply_count": "Допис отримав {count, plural, one {# відповідь} few {# відповіді} many {# відповідей} other {# відповіді}}.",
  "annual_report.summary.highlighted_post.title": "Найпопулярніший допис",
  "annual_report.summary.most_used_app.most_used_app": "найчастіше використовуваний застосунок",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "найчастіший хештег",
  "annual_report.summary.new_posts.new_posts": "нові дописи",
  "annual_report.summary.percentile.text": "<topLabel>Це виводить вас у топ</topLabel><percentage></percentage><bottomLabel> користувачів Mastodon.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Ми не скажемо Bernie.",
  "attachments_list.unprocessed": "(не оброблено)",
  "audio.hide": "Сховати аудіо",
  "block_modal.remote_users_caveat": "Ми попросимо сервер {domain} поважати ваше рішення. Однак дотримання вимог не гарантується, оскільки деякі сервери можуть обробляти блоки по-різному. Загальнодоступні дописи все ще можуть бути видимими для користувачів, які не увійшли в систему.",
  "block_modal.show_less": "Згорнути",
  "block_modal.show_more": "Розгорнути",
  "block_modal.they_will_know": "Вони можуть бачити, що вони заблоковані.",
  "block_modal.title": "Заблокувати користувача?",
  "boost_modal.combo": "Ви можете натиснути {combo}, щоби пропустити це наступного разу",
  "boost_modal.reblog": "Поширити допис?",
  "boost_modal.undo_reblog": "Скасувати поширення?",
  "bundle_column_error.copy_stacktrace": "Копіювати звіт про помилку",
  "bundle_column_error.error.body": "Неможливо показати запитану сторінку. Це може бути спричинено помилкою у нашому коді, або через проблему сумісності з браузером.",
  "bundle_column_error.error.title": "О, ні!",
  "bundle_column_error.network.body": "Під час завантаження цієї сторінки сталася помилка. Це могло статися через тимчасову проблему з вашим інтернетом чи цим сервером.",
  "bundle_column_error.network.title": "Помилка мережі",
  "bundle_column_error.retry": "Спробуйте ще раз",
  "bundle_column_error.return": "На головну",
  "bundle_column_error.routing.body": "Запитувана сторінка не знайдена. Ви впевнені, що URL-адреса у панелі адрес правильна?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Закрити",
  "bundle_modal_error.message": "Щось пішло не так під час завантаження цього екрану.",
  "bundle_modal_error.retry": "Спробувати ще раз",
  "closed_registrations.other_server_instructions": "Оскільки Mastodon децентралізований, ви можете створити обліковий запис на іншому сервері й досі взаємодіяти з ним.",
  "closed_registrations_modal.description": "Створення облікового запису на {domain} наразі неможливе, але майте на увазі, що вам не потрібен обліковий запис саме на {domain}, щоб використовувати Mastodon.",
  "closed_registrations_modal.find_another_server": "Знайти інший сервер",
  "closed_registrations_modal.preamble": "Mastodon децентралізований, тож незалежно від того, де ви створюєте свій обліковий запис, ви зможете слідкувати та взаємодіяти з будь-ким на цьому сервері. Ви навіть можете розмістити його самостійно!",
  "closed_registrations_modal.title": "Реєстрація на Mastodon",
  "collections.edit_details": "Редагувати подробиці",
  "column.about": "Про застосунок",
  "column.blocks": "Заблоковані користувачі",
  "column.bookmarks": "Закладки",
  "column.community": "Локальна стрічка",
  "column.create_list": "Створити список",
  "column.direct": "Особисті згадки",
  "column.directory": "Переглянути профілі",
  "column.domain_blocks": "Заблоковані домени",
  "column.edit_list": "Редагувати список",
  "column.favourites": "Уподобане",
  "column.firehose": "Стрічка новин",
  "column.follow_requests": "Запити на підписку",
  "column.home": "Головна",
  "column.list_members": "Керувати учасниками списку",
  "column.lists": "Списки",
  "column.mutes": "Приховані користувачі",
  "column.notifications": "Сповіщення",
  "column.pins": "Закріплені дописи",
  "column.public": "Глобальна стрічка",
  "column_back_button.label": "Назад",
  "column_header.hide_settings": "Приховати налаштування",
  "column_header.moveLeft_settings": "Змістити колонку вліво",
  "column_header.moveRight_settings": "Змістити колонку вправо",
  "column_header.pin": "Закріпити",
  "column_header.show_settings": "Показати налаштування",
  "column_header.unpin": "Відкріпити",
  "column_search.cancel": "Скасувати",
  "community.column_settings.local_only": "Лише локальні",
  "community.column_settings.media_only": "Лише з медіа",
  "community.column_settings.remote_only": "Лише віддалені",
  "compose.error.blank_post": "Допис не може бути порожнім.",
  "compose.language.change": "Змінити мову",
  "compose.language.search": "Шукати мови...",
  "compose.published.body": "Допис опубліковано.",
  "compose.published.open": "Відкрити",
  "compose.saved.body": "Допис збережено.",
  "compose_form.direct_message_warning_learn_more": "Дізнатися більше",
  "compose_form.encryption_warning": "Дописи на Mastodon не захищені шифруванням. Не поширюйте жодну делікатну інформацію.",
  "compose_form.hashtag_warning": "Цього допису не буде під жодним гештеґом, оскільки він не є загальнодоступним. За гештеґом можна шукати лише публічні дописи.",
  "compose_form.lock_disclaimer": "Ваш обліковий запис не {locked}. Будь-який користувач може підписатися на вас та переглядати ваші дописи для підписників.",
  "compose_form.lock_disclaimer.lock": "приватний",
  "compose_form.placeholder": "Що у вас на думці?",
  "compose_form.poll.duration": "Тривалість опитування",
  "compose_form.poll.multiple": "Кілька варіантів",
  "compose_form.poll.option_placeholder": "Варіант {number}",
  "compose_form.poll.single": "Один вибір",
  "compose_form.poll.switch_to_multiple": "Дозволити вибір декількох відповідей",
  "compose_form.poll.switch_to_single": "Перемкнути у режим вибору однієї відповіді",
  "compose_form.poll.type": "Стиль",
  "compose_form.publish": "Опублікувати",
  "compose_form.reply": "Відповісти",
  "compose_form.save_changes": "Оновити",
  "compose_form.spoiler.marked": "Прибрати попередження про вміст",
  "compose_form.spoiler.unmarked": "Додати попередження про вміст",
  "compose_form.spoiler_placeholder": "Попередження про вміст (необов'язково)",
  "confirmation_modal.cancel": "Скасувати",
  "confirmations.block.confirm": "Заблокувати",
  "confirmations.delete.confirm": "Видалити",
  "confirmations.delete.message": "Ви впевнені, що хочете видалити цей допис?",
  "confirmations.delete.title": "Видалити допис?",
  "confirmations.delete_collection.confirm": "Видалити",
  "confirmations.delete_list.confirm": "Видалити",
  "confirmations.delete_list.message": "Ви впевнені, що хочете видалити цей список назавжди?",
  "confirmations.delete_list.title": "Видалити список?",
  "confirmations.discard_draft.confirm": "Скасувати та продовжити",
  "confirmations.discard_draft.edit.cancel": "Продовжити редагування",
  "confirmations.discard_edit_media.confirm": "Відкинути",
  "confirmations.discard_edit_media.message": "У вас є незбережені зміни в описі медіа або попереднього перегляду, все одно відкинути їх?",
  "confirmations.follow_to_list.confirm": "Підписатися і додати до списку",
  "confirmations.follow_to_list.message": "Ви повинні слідувати за {name}, щоб додати до списку.",
  "confirmations.follow_to_list.title": "Підписатися на користувача?",
  "confirmations.logout.confirm": "Вийти",
  "confirmations.logout.message": "Ви впевнені, що хочете вийти?",
  "confirmations.logout.title": "Вийти?",
  "confirmations.missing_alt_text.confirm": "Додати альтернативний текст",
  "confirmations.missing_alt_text.message": "У вашому дописі є медіа без альтернативного тексту. Додавання опису допоможе зробити ваші матеріали доступними для більшої кількості людей.",
  "confirmations.missing_alt_text.secondary": "Все одно опублікувати",
  "confirmations.missing_alt_text.title": "Додати альтернативний текст?",
  "confirmations.mute.confirm": "Приховати",
  "confirmations.private_quote_notify.cancel": "Назад до редагування",
  "confirmations.private_quote_notify.confirm": "Оприлюднити допис",
  "confirmations.private_quote_notify.do_not_show_again": "Більше не показувати цього повідомлення",
  "confirmations.private_quote_notify.message": "Ті, кого ви цитуєте чи згадуєте, отримають сповіщення й зможуть переглянути ваш допис, навіть якщо не підписані на вас.",
  "confirmations.private_quote_notify.title": "Поширити підписникам і згаданим користувачам?",
  "confirmations.quiet_post_quote_info.dismiss": "Більше не нагадувати",
  "confirmations.quiet_post_quote_info.got_it": "Зрозуміло",
  "confirmations.quiet_post_quote_info.message": "Цитати тихого публічного допису не буде показано в стрічках трендів.",
  "confirmations.quiet_post_quote_info.title": "Цитування тихих публічних дописів",
  "confirmations.redraft.confirm": "Видалити та виправити",
  "confirmations.redraft.message": "Ви впевнені, що хочете видалити цей допис та переписати його? Додавання у вибране та поширення буде втрачено, а відповіді на оригінальний допис залишаться без першоджерела.",
  "confirmations.redraft.title": "Видалити та переробити допис?",
  "confirmations.remove_from_followers.confirm": "Вилучити підписника",
  "confirmations.remove_from_followers.message": "Точно відписати {name} від вас?",
  "confirmations.remove_from_followers.title": "Вилучити підписника?",
  "confirmations.revoke_quote.confirm": "Видалити публікацію",
  "confirmations.revoke_quote.message": "Цю дію не можна скасувати.",
  "confirmations.revoke_quote.title": "Видалити публікацію?",
  "confirmations.unblock.confirm": "Розблокувати",
  "confirmations.unblock.title": "Розблокувати {name}?",
  "confirmations.unfollow.confirm": "Відписатися",
  "confirmations.unfollow.title": "Відписатись від {name}?",
  "confirmations.withdraw_request.confirm": "Відкликати запит",
  "confirmations.withdraw_request.title": "Відкликати запит на підписку на {name}?",
  "content_warning.hide": "Сховати допис",
  "content_warning.show": "Усе одно показати",
  "content_warning.show_more": "Показати більше",
  "conversation.delete": "Видалити бесіду",
  "conversation.mark_as_read": "Позначити як прочитане",
  "conversation.open": "Переглянути бесіду",
  "conversation.with": "З {names}",
  "copy_icon_button.copied": "Скопійовано до буфера обміну",
  "copypaste.copied": "Скопійовано",
  "copypaste.copy_to_clipboard": "Копіювати до буфера обміну",
  "directory.federated": "З відомого федесвіту",
  "directory.local": "Лише з домену {domain}",
  "directory.new_arrivals": "Нові надходження",
  "directory.recently_active": "Нещодавно активні",
  "disabled_account_banner.account_settings": "Налаштування облікового запису",
  "disabled_account_banner.text": "Ваш обліковий запис {disabledAccount} наразі вимкнений.",
  "dismissable_banner.community_timeline": "Це останні публічні дописи від людей, чиї облікові записи розміщені на {domain}.",
  "dismissable_banner.dismiss": "Відхилити",
  "dismissable_banner.public_timeline": "Це найновіші загальнодоступні дописи від людей у федіверсі, на яких підписані люди в {domain}.",
  "domain_block_modal.block": "Блокувати сервер",
  "domain_block_modal.block_account_instead": "Блокувати @{name} натомість",
  "domain_block_modal.they_can_interact_with_old_posts": "Люди з цього сервера можуть взаємодіяти зі своїми старими дописами.",
  "domain_block_modal.they_cant_follow": "Ніхто з цього сервера не може слідкувати за вами.",
  "domain_block_modal.they_wont_know": "Вони не знають, що їх заблоковано.",
  "domain_block_modal.title": "Заблокувати домен?",
  "domain_block_modal.you_will_lose_num_followers": "Ви втратите {followersCount, plural, one {{followersCountDisplay} підписника} few {{followersCountDisplay} підписника} many {{followersCountDisplay} підписників} other {{followersCountDisplay} підписника}} та {followingCount, plural, one {{followingCountDisplay} особу, за якою ви стежите} few {{followingCountDisplay} особи, за якими ви стежите} many {{followingCountDisplay} осіб, за якими ви стежите} other {{followingCountDisplay} особу, за якою ви стежите}}.",
  "domain_block_modal.you_will_lose_relationships": "Ви втратите всіх підписників і людей, на яких ви підписані.",
  "domain_block_modal.you_wont_see_posts": "Ви не бачитимете дописів і сповіщень від користувачів на цьому сервері.",
  "dropdown.empty": "Оберіть варіант",
  "embed.instructions": "Вбудуйте цей допис до вашого вебсайту, скопіювавши код нижче.",
  "embed.preview": "Ось який вигляд це матиме:",
  "emoji_button.activity": "Діяльність",
  "emoji_button.clear": "Очистити",
  "emoji_button.custom": "Власні",
  "emoji_button.flags": "Прапори",
  "emoji_button.food": "Їжа та напої",
  "emoji_button.label": "Вставити емоджі",
  "emoji_button.nature": "Природа",
  "emoji_button.not_found": "Відповідних емоджі не знайдено",
  "emoji_button.objects": "Предмети",
  "emoji_button.people": "Люди",
  "emoji_button.recent": "Часто використовувані",
  "emoji_button.search": "Шукати...",
  "emoji_button.search_results": "Результати пошуку",
  "emoji_button.symbols": "Символи",
  "emoji_button.travel": "Подорожі та місця",
  "empty_column.account_hides_collections": "Цей користувач вирішив не робити цю інформацію доступною",
  "empty_column.account_suspended": "Обліковий запис заблоковано",
  "empty_column.account_timeline": "Тут немає дописів!",
  "empty_column.account_unavailable": "Профіль недоступний",
  "empty_column.blocks": "Ви ще не заблокували жодного користувача.",
  "empty_column.bookmarked_statuses": "У вас ще немає дописів у закладках. Коли ви щось додасте до закладок, воно з'явиться тут.",
  "empty_column.community": "Локальна стрічка порожня. Напишіть щось, щоб розігріти народ!",
  "empty_column.direct": "У вас ще немає жодних особистих згадок. Коли ви надсилаєте чи отримуєте повідомлення, воно з'явиться тут.",
  "empty_column.domain_blocks": "Тут поки немає прихованих доменів.",
  "empty_column.explore_statuses": "Нема нічого популярного. Подивіться пізніше!",
  "empty_column.favourited_statuses": "У вас ще немає вподобаних дописів. Коли ви щось вподобаєте, воно з'явиться тут.",
  "empty_column.favourites": "Ніхто ще не вподобав цей допис. Коли хтось це зробить, він з'явиться тут.",
  "empty_column.follow_requests": "У вас ще немає запитів на підписку. Коли ви їх отримаєте, вони з'являться тут.",
  "empty_column.followed_tags": "Ви ще не підписані на хештеґи. Коли ви це зробите, вони з'являться тут.",
  "empty_column.hashtag": "Дописів з цим гештеґом поки не існує.",
  "empty_column.home": "Ваша стрічка порожня! Підпишіться на інших, щоб її заповнити.",
  "empty_column.list": "Цей список порожній. Коли його учасники додадуть нові дописи, вони з'являться тут.",
  "empty_column.mutes": "Ви ще не приховали жодного користувача.",
  "empty_column.notification_requests": "Усе чисто! Тут нічого немає. Коли ви отримаєте нові сповіщення, вони з'являться тут відповідно до ваших налаштувань.",
  "empty_column.notifications": "У вас ще немає сповіщень. Коли інші люди почнуть взаємодіяти з вами, ви побачите їх тут.",
  "empty_column.public": "Тут поки нічого немає! Опублікуйте щось, або вручну підпишіться на користувачів інших серверів, щоб заповнити стрічку",
  "error.unexpected_crash.explanation": "Через помилку у нашому коді або несумісність браузера, ця сторінка не може бути зображена коректно.",
  "error.unexpected_crash.explanation_addons": "Неможливо правильно показати цю сторінку. Ймовірно, цю помилку спричинило розширення браузера або автоматичний засіб перекладу.",
  "error.unexpected_crash.next_steps": "Спробуйте перезавантажити сторінку. Якщо це не допоможе, ви все ще зможете використовувати Mastodon через інший браузер або рідний застосунок.",
  "error.unexpected_crash.next_steps_addons": "Спробуйте їх вимкнути та оновити сторінку. Якщо це не допомагає, ви можете використовувати Mastodon через інший браузер або окремий застосунок.",
  "errors.unexpected_crash.copy_stacktrace": "Скопіювати трасування стека у буфер обміну",
  "errors.unexpected_crash.report_issue": "Повідомити про проблему",
  "explore.suggested_follows": "Люди",
  "explore.title": "Тренди",
  "explore.trending_links": "Новини",
  "explore.trending_statuses": "Дописи",
  "explore.trending_tags": "Хештеґи",
  "filter_modal.added.context_mismatch_explanation": "Ця категорія фільтра не застосовується до контексту, в якому ви отримали доступ до цього допису. Якщо ви хочете, щоб дописи також фільтрувалися за цим контекстом, вам доведеться редагувати фільтр.",
  "filter_modal.added.context_mismatch_title": "Невідповідність контексту!",
  "filter_modal.added.expired_explanation": "Категорія цього фільтра застаріла, Вам потрібно змінити дату закінчення терміну дії, щоб застосувати її.",
  "filter_modal.added.expired_title": "Застарілий фільтр!",
  "filter_modal.added.review_and_configure": "Щоб розглянути та далі налаштувати цю категорію фільтрів, перейдіть на {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Налаштування фільтра",
  "filter_modal.added.settings_link": "сторінка налаштувань",
  "filter_modal.added.short_explanation": "Цей допис було додано до такої категорії фільтра: {title}.",
  "filter_modal.added.title": "Фільтр додано!",
  "filter_modal.select_filter.context_mismatch": "не застосовується до цього контексту",
  "filter_modal.select_filter.expired": "застарілий",
  "filter_modal.select_filter.prompt_new": "Нова категорія: {name}",
  "filter_modal.select_filter.search": "Пошук або створення",
  "filter_modal.select_filter.subtitle": "Використати наявну категорію або створити нову",
  "filter_modal.select_filter.title": "Фільтрувати цей допис",
  "filter_modal.title.status": "Фільтрувати допис",
  "filter_warning.matches_filter": "Збігається з фільтром “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "Від {count, plural, =0 {жодної особи} one {однієї особи} few {# осіб} many {# осіб} other {# особи}}, яких ви можете знати",
  "filtered_notifications_banner.title": "Відфільтровані сповіщення",
  "firehose.all": "Всі",
  "firehose.local": "Цей сервер",
  "firehose.remote": "Інші сервери",
  "follow_request.authorize": "Авторизувати",
  "follow_request.reject": "Відмовити",
  "follow_requests.unlocked_explanation": "Хоча ваш обліковий запис не заблоковано, персонал {domain} припускає, що, можливо, ви хотіли б переглянути ці запити на підписку.",
  "follow_suggestions.curated_suggestion": "Відібрано командою",
  "follow_suggestions.dismiss": "Більше не показувати",
  "follow_suggestions.featured_longer": "Вибрано командою {domain} вручну",
  "follow_suggestions.friends_of_friends_longer": "Популярні серед людей, за якими ви слідкуєте",
  "follow_suggestions.hints.featured": "Цей профіль був обраний командою {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Цей профіль популярний серед тих людей, на яких ви підписані.",
  "follow_suggestions.hints.most_followed": "За цим профілем один з найпопулярніших на {domain}.",
  "follow_suggestions.hints.most_interactions": "Нещодавно цей профіль отримав багато уваги на {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Цей профіль схожий на профілі, за якими ви стежили останнім часом.",
  "follow_suggestions.personalized_suggestion": "Персоналізована пропозиція",
  "follow_suggestions.popular_suggestion": "Популярна пропозиція",
  "follow_suggestions.popular_suggestion_longer": "Популярно на {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Схожі на профілі, за якими ви нещодавно стежили",
  "follow_suggestions.view_all": "Переглянути все",
  "follow_suggestions.who_to_follow": "На кого підписатися",
  "followed_tags": "Відстежувані хештеґи",
  "footer.about": "Про проєкт",
  "footer.about_mastodon": "Про Mastodon",
  "footer.about_server": "Про {domain}",
  "footer.about_this_server": "Про сервер",
  "footer.directory": "Каталог профілів",
  "footer.get_app": "Завантажити застосунок",
  "footer.keyboard_shortcuts": "Комбінації клавіш",
  "footer.privacy_policy": "Політика приватності",
  "footer.source_code": "Перегляд програмного коду",
  "footer.status": "Статус",
  "footer.terms_of_service": "Умови використання",
  "getting_started.heading": "Розпочати",
  "hashtag.admin_moderation": "Відкрити інтерфейс модерації для #{name}",
  "hashtag.column_header.tag_mode.all": "та {additional}",
  "hashtag.column_header.tag_mode.any": "або {additional}",
  "hashtag.column_header.tag_mode.none": "без {additional}",
  "hashtag.column_settings.select.no_options_message": "Пропозицій не знайдено",
  "hashtag.column_settings.select.placeholder": "Введіть гештеґи…",
  "hashtag.column_settings.tag_mode.all": "Усе зі списку",
  "hashtag.column_settings.tag_mode.any": "Який-небудь зі списку",
  "hashtag.column_settings.tag_mode.none": "Жоден зі списку",
  "hashtag.column_settings.tag_toggle": "Додати додаткові теґи до цього стовпчика",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} учасник} few {{counter} учасники} many {{counter} учасників} other {{counter} учасник}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} допис} few {{counter} дописи} many {{counter} дописів} other {{counter} допис}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} допис} few {{counter} дописи} many {{counter} дописів} other {{counter} допис}} сьогодні",
  "hashtag.follow": "Стежити за хештегом",
  "hashtag.mute": "Ігнорувати #{hashtag}",
  "hashtag.unfollow": "Не стежити за хештегом",
  "hashtags.and_other": "…і {count, plural, other {ще #}}",
  "hints.profiles.followers_may_be_missing": "Підписники цього профілю можуть бути не показані.",
  "hints.profiles.follows_may_be_missing": "Підписки цього профілю можуть бути не показані.",
  "hints.profiles.posts_may_be_missing": "Деякі дописи від цього профілю можуть бути не показані.",
  "hints.profiles.see_more_followers": "Переглянути більше підписників на {domain}",
  "hints.profiles.see_more_follows": "Переглянути більше підписок на {domain}",
  "hints.profiles.see_more_posts": "Переглянути більше дописів на {domain}",
  "home.column_settings.show_quotes": "Показувати цитати",
  "home.column_settings.show_reblogs": "Показувати поширення",
  "home.column_settings.show_replies": "Показувати відповіді",
  "home.hide_announcements": "Приховати оголошення",
  "home.pending_critical_update.body": "Якнайшвидше оновіть свій сервер Mastodon!",
  "home.pending_critical_update.link": "Переглянути оновлення",
  "home.pending_critical_update.title": "Доступне критичне оновлення безпеки!",
  "home.show_announcements": "Показати оголошення",
  "ignore_notifications_modal.disclaimer": "Mastodon не може повідомити користувачів, що ви проігнорували їх повідомлення. Ігнорування сповіщень не зупинить надсилання повідомлень.",
  "ignore_notifications_modal.filter_instead": "Натомість фільтрувати",
  "ignore_notifications_modal.filter_to_act_users": "Ви все ще зможете прийняти, відхилити або поскаржитися на користувачів",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Фільтрування допомагає уникнути потенційної плутанини",
  "ignore_notifications_modal.filter_to_review_separately": "Ви можете переглянути відфільтровані сповіщення окремо",
  "ignore_notifications_modal.ignore": "Ігнорувати сповіщення",
  "ignore_notifications_modal.limited_accounts_title": "Ігнорувати сповіщення від модерованих облікових записів?",
  "ignore_notifications_modal.new_accounts_title": "Ігнорувати сповіщення від нових облікових записів?",
  "ignore_notifications_modal.not_followers_title": "Ігнорувати сповіщення від людей, які не підписані на вас?",
  "ignore_notifications_modal.not_following_title": "Ігнорувати сповіщення від людей, на яких ви не підписалися?",
  "ignore_notifications_modal.private_mentions_title": "Ігнорувати сповіщення від небажаних приватних згадок?",
  "info_button.label": "Довідка",
  "info_button.what_is_alt_text": "<h1>Що таке альтернативний текст?</h1> <p>Альтернативний текст містить описи зображень для людей з вадами зору, низькошвидкісними з'єднаннями або тих, хто шукає додатковий контекст.</p> <p>Ви можете покращити доступність і розуміння для всіх, написавши чіткий та лаконічний альтернативний текст.</p> <ul> <li>Позначайте важливі елементи</li> <li>Охоплюйте текст у картинках</li> <li>Використовуйте звичайну структуру речень</li> <li>Уникайте надлишкової інформації</li> <li>Зосередьтеся на тенденціях і ключових висновках у складних візуальних формах (наприклад, діаграмах або картах)</li> </ul>",
  "interaction_modal.action": "Щоб взаємодіяти з {name}, вам потрібно увійти в свій обліковий запис на будь-якому сервері Mastodon.",
  "interaction_modal.go": "Вперед",
  "interaction_modal.no_account_yet": "Ще не зареєстровані?",
  "interaction_modal.on_another_server": "На іншому сервері",
  "interaction_modal.on_this_server": "На цьому сервері",
  "interaction_modal.title": "Увійдіть, щоб продовжити",
  "interaction_modal.username_prompt": "Наприклад, {example}",
  "intervals.full.days": "{number, plural, one {# день} few {# дні} other {# днів}}",
  "intervals.full.hours": "{number, plural, one {# година} few {# години} other {# годин}}",
  "intervals.full.minutes": "{number, plural, one {# хвилина} few {# хвилини} other {# хвилин}}",
  "keyboard_shortcuts.back": "Перейти назад",
  "keyboard_shortcuts.blocked": "Відкрити список заблокованих користувачів",
  "keyboard_shortcuts.boost": "Поширити допис",
  "keyboard_shortcuts.column": "Фокусуватися на одній з колонок",
  "keyboard_shortcuts.compose": "Фокусуватися на полі введення",
  "keyboard_shortcuts.description": "Опис",
  "keyboard_shortcuts.down": "Рухатися вниз стрічкою",
  "keyboard_shortcuts.enter": "Відкрити допис",
  "keyboard_shortcuts.favourite": "Уподобати допис",
  "keyboard_shortcuts.favourites": "Відкрити список уподобаного",
  "keyboard_shortcuts.federated": "Відкрити глобальну стрічку",
  "keyboard_shortcuts.heading": "Комбінації клавіш",
  "keyboard_shortcuts.home": "Відкрити домашню стрічку",
  "keyboard_shortcuts.hotkey": "Гаряча клавіша",
  "keyboard_shortcuts.legend": "Показати легенду",
  "keyboard_shortcuts.load_more": "Фокусуватися на кнопці «Завантажити більше»",
  "keyboard_shortcuts.local": "Відкрити локальну стрічку",
  "keyboard_shortcuts.mention": "Згадати автора",
  "keyboard_shortcuts.muted": "Відкрити список прихованих користувачів",
  "keyboard_shortcuts.my_profile": "Відкрити ваш профіль",
  "keyboard_shortcuts.notifications": "Відкрити колонку сповіщень",
  "keyboard_shortcuts.open_media": "Відкрити медіа",
  "keyboard_shortcuts.pinned": "Відкрити список закріплених дописів",
  "keyboard_shortcuts.profile": "Відкрити профіль автора",
  "keyboard_shortcuts.quote": "Цитувати допис",
  "keyboard_shortcuts.reply": "Відповісти",
  "keyboard_shortcuts.requests": "Відкрити список охочих підписатися",
  "keyboard_shortcuts.search": "Сфокусуватися на пошуку",
  "keyboard_shortcuts.spoilers": "Показати/приховати поле попередження про вміст",
  "keyboard_shortcuts.start": "Відкрити колонку \"Розпочати\"",
  "keyboard_shortcuts.toggle_hidden": "Показати/приховати текст під попередженням про вміст",
  "keyboard_shortcuts.toggle_sensitivity": "Показати/приховати медіа",
  "keyboard_shortcuts.toot": "Створити новий допис",
  "keyboard_shortcuts.unfocus": "Розфокусуватися з нового допису чи пошуку",
  "keyboard_shortcuts.up": "Рухатися вгору списком",
  "learn_more_link.got_it": "Зрозуміло",
  "learn_more_link.learn_more": "Докладніше",
  "lightbox.close": "Закрити",
  "lightbox.next": "Далі",
  "lightbox.previous": "Назад",
  "lightbox.zoom_in": "Масштаб за реальним розміром",
  "lightbox.zoom_out": "Збільшити відповідно до розміру",
  "limited_account_hint.action": "Усе одно показати профіль",
  "link_preview.author": "Від {name}",
  "link_preview.more_from_author": "Більше від {name}",
  "link_preview.shares": "{count, plural, one {{counter} допис} few {{counter} дописи} many {{counter} дописів} other {{counter} допис}}",
  "lists.add_member": "Додати",
  "lists.add_to_list": "Додати до списку",
  "lists.add_to_lists": "Додати {name} до списку",
  "lists.create": "Створити",
  "lists.create_a_list_to_organize": "Створіть новий список, щоб упорядкувати домашню стрічку",
  "lists.create_list": "Створити список",
  "lists.delete": "Видалити список",
  "lists.done": "Готово",
  "lists.edit": "Редагувати список",
  "lists.exclusive": "Сховати учасників на головній сторінці",
  "lists.exclusive_hint": "Якщо хтось є у цьому списку, сховайте їх на своїй домашній сторінці, щоб не бачити їхні дописи двічі.",
  "lists.find_users_to_add": "Знайти користувачів, щоб додати їх",
  "lists.list_members_count": "{count, plural, one {# member} other {# members}}",
  "lists.list_name": "Назва списку",
  "lists.new_list_name": "Нова назва списку",
  "lists.no_lists_yet": "Поки що немає списків.",
  "lists.no_members_yet": "Ще немає учасників.",
  "lists.no_results_found": "Результатів не знайдено.",
  "lists.remove_member": "Видалити",
  "lists.replies_policy.followed": "Будь-який відстежуваний користувач",
  "lists.replies_policy.list": "Учасники списку",
  "lists.replies_policy.none": "Ніхто",
  "lists.save": "Зберегти",
  "lists.search": "Пошук",
  "lists.show_replies_to": "Включати відповіді також зі списку учасників",
  "load_pending": "{count, plural, one {# новий елемент} other {# нових елементів}}",
  "loading_indicator.label": "Завантаження…",
  "media_gallery.hide": "Сховати",
  "moved_to_account_banner.text": "Ваш обліковий запис {disabledAccount} наразі вимкнений, оскільки вас перенесено до {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Сховати зі сповіщень",
  "mute_modal.hide_options": "Сховати опції",
  "mute_modal.indefinite": "Доки я не перестану ігнорувати їх",
  "mute_modal.show_options": "Показати опції",
  "mute_modal.they_can_mention_and_follow": "Вони зможуть згадувати та стежити за вами, але ви їх не бачитимете.",
  "mute_modal.they_wont_know": "Вони не знатимуть, що їх ігнорують.",
  "mute_modal.title": "Ігнорувати користувача?",
  "mute_modal.you_wont_see_mentions": "Ви не бачитимете дописів, де їх згадано.",
  "mute_modal.you_wont_see_posts": "Вони все ще можуть бачити ваші дописи, але ви не бачитимете їхніх.",
  "navigation_bar.about": "Про застосунок",
  "navigation_bar.account_settings": "Пароль і безпека",
  "navigation_bar.administration": "Адміністрування",
  "navigation_bar.advanced_interface": "Відкрити в розширеному вебінтерфейсі",
  "navigation_bar.automated_deletion": "Автовидалення допису",
  "navigation_bar.blocks": "Заблоковані користувачі",
  "navigation_bar.bookmarks": "Закладки",
  "navigation_bar.direct": "Особисті згадки",
  "navigation_bar.domain_blocks": "Заблоковані домени",
  "navigation_bar.favourites": "Уподобане",
  "navigation_bar.filters": "Приховані слова",
  "navigation_bar.follow_requests": "Запити на підписку",
  "navigation_bar.followed_tags": "Відстежувані хештеґи",
  "navigation_bar.follows_and_followers": "Підписки та підписники",
  "navigation_bar.import_export": "Імпорт та експорт",
  "navigation_bar.lists": "Списки",
  "navigation_bar.live_feed_local": "Онлайн стрічка (локальна)",
  "navigation_bar.live_feed_public": "Онлайн стрічка (публічна)",
  "navigation_bar.logout": "Вийти",
  "navigation_bar.moderation": "Модерування",
  "navigation_bar.more": "Ще",
  "navigation_bar.mutes": "Приховані користувачі",
  "navigation_bar.opened_in_classic_interface": "Дописи, облікові записи та інші специфічні сторінки усталено відкриваються в класичному вебінтерфейсі.",
  "navigation_bar.preferences": "Налаштування",
  "navigation_bar.privacy_and_reach": "Приватність і досяжність",
  "navigation_bar.search": "Пошук",
  "navigation_bar.search_trends": "Пошук / Популярність",
  "navigation_panel.collapse_followed_tags": "Згорнути меню хештегів",
  "navigation_panel.collapse_lists": "Згорнути меню списку",
  "navigation_panel.expand_followed_tags": "Розгорнути меню хештегів",
  "navigation_panel.expand_lists": "Розгорнути меню списку",
  "not_signed_in_indicator.not_signed_in": "Ви повинні увійти, щоб отримати доступ до цього ресурсу.",
  "notification.admin.report": "Скарга від {name} на {target}",
  "notification.admin.report_account": "{name} повідомляє про {count, plural, one {один допис} few {# дописи} many {# дописів} other {# дописів}} від {target} в категорії {category}",
  "notification.admin.report_account_other": "{name} повідомляє про {count, plural, one {один допис} few {# дописи} many {# дописів} other {# дописів}} від {target}",
  "notification.admin.report_statuses": "{name} повідомляє про {target} в категорії {category}",
  "notification.admin.report_statuses_other": "{name} повідомляє про {target}",
  "notification.admin.sign_up": "{name} приєдналися",
  "notification.admin.sign_up.name_and_others": "{name} та {count, plural, one {# інший} few {# інших} many {# інших} other {# інший}} зареєструвалися",
  "notification.annual_report.message": "#Wrapstodon за {year} чекає на вас! Дізнайтеся про найяскравіші та пам'ятні моменти вашого року на Mastodon!",
  "notification.annual_report.view": "Переглянути #Wrapstodon",
  "notification.favourite": "Ваш допис сподобався {name}",
  "notification.favourite.name_and_others_with_link": "{name} та <a>{count, plural, one {# інший} few {# інших} many {# інших} other {# інший}}</a> вподобали ваш допис",
  "notification.favourite_pm": "{name} додає вашу особисту згадку до вибраного",
  "notification.favourite_pm.name_and_others_with_link": "{name} та <a>{count, plural, one {# інший} few {# інших} many {# інших} other {# інший}}</a> додали вашу особисту згадку до вибраного",
  "notification.follow": "{name} підписалися на вас",
  "notification.follow.name_and_others": "{name} та <a>{count, plural, one {# інший} few {# інших} many {# інших} other {# інший}}</a> стежать за вами",
  "notification.follow_request": "{name} відправили запит на підписку",
  "notification.follow_request.name_and_others": "{name} та {count, plural, one {# інший} few {# інших} many {# інших} other {# інший}} надсилають вам запит на стеження",
  "notification.label.mention": "Згадка",
  "notification.label.private_mention": "Особиста згадка",
  "notification.label.private_reply": "Приватна відповідь",
  "notification.label.quote": "{name} цитує ваш допис",
  "notification.label.reply": "Відповідь",
  "notification.mention": "Згадка",
  "notification.mentioned_you": "{name} згадує вас",
  "notification.moderation-warning.learn_more": "Докладніше",
  "notification.moderation_warning": "Ви отримали попередження модерації",
  "notification.moderation_warning.action_delete_statuses": "Деякі з ваших дописів було вилучено.",
  "notification.moderation_warning.action_disable": "Ваш обліковий запис було вимкнено.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Деякі з ваших дописів були позначені делікатними.",
  "notification.moderation_warning.action_none": "Ваш обліковий запис отримав попередження модерації.",
  "notification.moderation_warning.action_sensitive": "Відтепер ваші дописи будуть позначені делікатними.",
  "notification.moderation_warning.action_silence": "Ваш обліковий запис було обмежено.",
  "notification.moderation_warning.action_suspend": "Ваш обліковий запис було заблоковано.",
  "notification.own_poll": "Ваше опитування завершилося",
  "notification.poll": "Опитування, в якому ви проголосували, завершено",
  "notification.quoted_update": "{name} редагує цитований вами допис",
  "notification.reblog": "{name} поширює ваш допис",
  "notification.reblog.name_and_others_with_link": "{name} та <a>{count, plural, one {# інший} few {# інших} many {# інших} other {# інший}}</a> поширили ваш допис",
  "notification.relationships_severance_event": "Втрачено з'єднання з {name}",
  "notification.relationships_severance_event.account_suspension": "Адміністратор з {from} призупинив {target}, що означає, що ви більше не можете отримувати оновлення від них або взаємодіяти з ними.",
  "notification.relationships_severance_event.domain_block": "Адміністратор з {from} заблокував {target}, включаючи {followersCount} ваших підписників і {followingCount , plural, one {# обліковий запис} few {# облікові записи} many {# облікових записів} other {# обліковий запис}}, на які ви підписані.",
  "notification.relationships_severance_event.learn_more": "Докладніше",
  "notification.relationships_severance_event.user_domain_block": "Ви заблокували {target}, видаливши {followersCount} ваших підписників і {followingCount, plural, one {# обліковий запис} few {# облікові записи} many {# облікових записів} other {# обліковий запис}}, за якими ви стежите.",
  "notification.status": "{name} щойно дописує",
  "notification.update": "{name} змінює допис",
  "notification_requests.accept": "Прийняти",
  "notification_requests.accept_multiple": "{count, plural, one {Прийняти # запит…} few {Прийняти # запити…} many {Прийняти # запитів…} other {Прийняти # запит…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Прийняти запит} other {Прийняти запити}}",
  "notification_requests.confirm_accept_multiple.message": "Ви збираєтеся прийняти {count, plural, one {запит на сповіщення} few {# запити на сповіщення} many {# запитів на сповіщення} other {# запит на сповіщення}}. Ви впевнені, що хочете продовжити?",
  "notification_requests.confirm_accept_multiple.title": "Прийняти запит на сповіщення?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Відхилити запит} other {Відхилити запити}}",
  "notification_requests.confirm_dismiss_multiple.message": "Ви збираєтеся відхилити {count, plural, one {один запит на сповіщення} few {# запити на сповіщення} many {# запитів на сповіщення} other {# запит на сповіщення}}. Ви не зможете легко отримати доступ до {count, plural, one {нього} other {них}} пізніше. Ви впевнені, що хочете продовжити?",
  "notification_requests.confirm_dismiss_multiple.title": "Відхилити запити на сповіщення?",
  "notification_requests.dismiss": "Відхилити",
  "notification_requests.dismiss_multiple": "{count, plural, one {Відхилити # запит…} few {Відхилити # запити…} many {Відхилити # запитів…} other {Відхилити # запит…}}",
  "notification_requests.edit_selection": "Змінити",
  "notification_requests.exit_selection": "Готово",
  "notification_requests.explainer_for_limited_account": "Сповіщення від цього облікового запису фільтровані, оскільки обліковий запис обмежений модератором.",
  "notification_requests.explainer_for_limited_remote_account": "Сповіщення від цього облікового запису фільтровані, оскільки обліковий запис або його сервер обмежений модератором.",
  "notification_requests.maximize": "Розгорнути",
  "notification_requests.minimize_banner": "Мінімізувати відфільтрований банер сповіщень",
  "notification_requests.notifications_from": "Сповіщення від {name}",
  "notification_requests.title": "Відфільтровані сповіщення",
  "notification_requests.view": "Переглянути сповіщення",
  "notifications.clear": "Очистити сповіщення",
  "notifications.clear_confirmation": "Ви впевнені, що хочете назавжди видалити всі сповіщення?",
  "notifications.clear_title": "Очистити сповіщення?",
  "notifications.column_settings.admin.report": "Нові скарги:",
  "notifications.column_settings.admin.sign_up": "Нові реєстрації:",
  "notifications.column_settings.alert": "Сповіщення стільниці",
  "notifications.column_settings.favourite": "Уподобане:",
  "notifications.column_settings.filter_bar.advanced": "Показати всі категорії",
  "notifications.column_settings.filter_bar.category": "Панель швидкого фільтра",
  "notifications.column_settings.follow": "Нові підписники:",
  "notifications.column_settings.follow_request": "Нові запити на підписку:",
  "notifications.column_settings.group": "Групувати",
  "notifications.column_settings.mention": "Згадки:",
  "notifications.column_settings.poll": "Результати опитування:",
  "notifications.column_settings.push": "Push-сповіщення",
  "notifications.column_settings.quote": "Цитати:",
  "notifications.column_settings.reblog": "Поширення:",
  "notifications.column_settings.show": "Показати в стовпчику",
  "notifications.column_settings.sound": "Відтворювати звуки",
  "notifications.column_settings.status": "Нові дописи:",
  "notifications.column_settings.unread_notifications.category": "Непрочитані сповіщення",
  "notifications.column_settings.unread_notifications.highlight": "Виділити непрочитані сповіщення",
  "notifications.column_settings.update": "Зміни:",
  "notifications.filter.all": "Усі",
  "notifications.filter.boosts": "Поширення",
  "notifications.filter.favourites": "Уподобане",
  "notifications.filter.follows": "Підписки",
  "notifications.filter.mentions": "Згадки",
  "notifications.filter.polls": "Результати опитування",
  "notifications.filter.statuses": "Оновлення від людей, на яких ви підписані",
  "notifications.grant_permission": "Надати дозвіл.",
  "notifications.group": "{count} сповіщень",
  "notifications.mark_as_read": "Позначити всі сповіщення прочитаними",
  "notifications.permission_denied": "Сповіщення стільниці недоступні через раніше відхилений запит дозволів для браузера",
  "notifications.permission_denied_alert": "Сповіщення не можна ввімкнути оскільки у дозволі вже було відмовлено раніше",
  "notifications.permission_required": "Сповіщення на стільниці не доступні, оскільки необхідний дозвіл не надано.",
  "notifications.policy.accept": "Прийняти",
  "notifications.policy.accept_hint": "Показувати в сповіщеннях",
  "notifications.policy.drop": "Ігнорувати",
  "notifications.policy.drop_hint": "Відправити в нікуди, щоб більше не бачити",
  "notifications.policy.filter": "Фільтрувати",
  "notifications.policy.filter_hint": "Надіслати до відфільтрованих вхідних",
  "notifications.policy.filter_limited_accounts_hint": "Обмежено модераторами сервера",
  "notifications.policy.filter_limited_accounts_title": "Модеровані облікові записи",
  "notifications.policy.filter_new_accounts.hint": "Створено впродовж {days, plural, one {одного} few {# днів} many {# днів} other {# дня}}",
  "notifications.policy.filter_new_accounts_title": "Нові облікові записи",
  "notifications.policy.filter_not_followers_hint": "Включаючи людей, які стежать за вами менше {days, plural, one {one day} other {# days}}",
  "notifications.policy.filter_not_followers_title": "Люди не підписані на вас",
  "notifications.policy.filter_not_following_hint": "Доки ви не схвалюєте їх вручну",
  "notifications.policy.filter_not_following_title": "Люди, на яких ви не підписані",
  "notifications.policy.filter_private_mentions_hint": "Відфільтровується, якщо це не відповідь на вашу власну згадку або якщо ви відстежуєте відправника",
  "notifications.policy.filter_private_mentions_title": "Небажані приватні згадки",
  "notifications.policy.title": "Керувати сповіщеннями від…",
  "notifications_permission_banner.enable": "Увімкнути сповіщення стільниці",
  "notifications_permission_banner.how_to_control": "Щоб отримувати сповіщення, коли Mastodon не відкрито, увімкніть сповіщення стільниці. Ви можете контролювати, які типи взаємодій створюють сповіщення через кнопку {icon} вгорі після їхнього увімкнення.",
  "notifications_permission_banner.title": "Не проґавте нічого",
  "onboarding.follows.back": "Назад",
  "onboarding.follows.empty": "На жаль, жоден результат не може бути показаний просто зараз. Ви можете спробувати скористатися пошуком або переглядом сторінки огляду, щоб знайти людей для слідкування або повторіть спробу пізніше.",
  "onboarding.follows.search": "Пошук",
  "onboarding.follows.title": "Слідкуйте за людьми, щоб почати",
  "onboarding.profile.discoverable": "Зробити мій профіль видимим",
  "onboarding.profile.discoverable_hint": "Якщо ви погоджуєтеся на видимість у Mastodon, ваші дописи можуть з'являтися в результатах пошуку і трендах, і ваш профіль може бути запропоновано людям зі схожими з вашими інтересами.",
  "onboarding.profile.display_name": "Видиме ім'я",
  "onboarding.profile.display_name_hint": "Ваше повне ім'я або ваш псевдонім…",
  "onboarding.profile.note": "Біографія",
  "onboarding.profile.note_hint": "Ви можете @згадувати інших людей або #гештеґи…",
  "onboarding.profile.title": "Налаштування профілю",
  "onboarding.profile.upload_avatar": "Завантажити зображення профілю",
  "onboarding.profile.upload_header": "Завантажити заголовок профілю",
  "password_confirmation.exceeds_maxlength": "Підтвердження пароля перевищує максимально допустиму довжину пароля",
  "password_confirmation.mismatching": "Підтвердження пароля не збігається",
  "picture_in_picture.restore": "Повернути назад",
  "poll.closed": "Закрито",
  "poll.refresh": "Оновити",
  "poll.reveal": "Переглянути результати",
  "poll.total_people": "{count, plural, one {# особа} few {# особи} many {# осіб} other {# особи}}",
  "poll.total_votes": "{count, plural, one {# голос} few {# голоси} many {# голосів} other {# голосів}}",
  "poll.vote": "Проголосувати",
  "poll.voted": "Ви проголосували за цю відповідь",
  "poll.votes": "{votes, plural, one {# голос} few {# голоси} many {# голосів} other {# голоса}}",
  "poll_button.add_poll": "Додати опитування",
  "poll_button.remove_poll": "Видалити опитування",
  "privacy.change": "Змінити видимість допису",
  "privacy.direct.long": "Усі згадані в дописі",
  "privacy.direct.short": "Особиста згадка",
  "privacy.private.long": "Лише ваші підписники",
  "privacy.private.short": "Підписники",
  "privacy.public.long": "Усі з Mastodon",
  "privacy.public.short": "Публічно",
  "privacy.quote.disabled": "{visibility}, цитування вимкнено",
  "privacy.quote.limited": "{visibility}, цитування обмежено",
  "privacy.unlisted.additional": "Має таку ж поведінку, як у людей, але повідомлення не з'являтимуться у стрічках або хештегах, оглядах, або пошуку Mastodon, навіть якщо ви використовуєте облікові записи.",
  "privacy.unlisted.long": "Сховано з результатів пошуку Mastodon, трендових і публічних стрічок",
  "privacy.unlisted.short": "Без додавання до стрічки",
  "privacy_policy.last_updated": "Оновлено {date}",
  "privacy_policy.title": "Політика приватності",
  "quote_error.edit": "Цитат не можна додавати під час редагування допису.",
  "quote_error.poll": "Одночасно цитувати й опитувати не можна.",
  "quote_error.private_mentions": "Одночасно цитувати й особисто когось згадувати не можна.",
  "quote_error.quote": "Дозволено лише одну цитату.",
  "quote_error.unauthorized": "Вам не дозволено цитувати цей допис.",
  "quote_error.upload": "Одночасно цитувати й додавати мультимедіа не можна.",
  "recommended": "Рекомендовано",
  "refresh": "Оновити",
  "regeneration_indicator.please_stand_by": "Будь ласка, очікуйте.",
  "regeneration_indicator.preparing_your_home_feed": "Готування вашої головної стрічки новин…",
  "relative_time.days": "{number}д",
  "relative_time.full.days": "{number, plural, one {# день} few {# дні} other {# днів}} тому",
  "relative_time.full.hours": "{number, plural, one {# година} few {# години} other {# годин}} тому",
  "relative_time.full.just_now": "щойно",
  "relative_time.full.minutes": "{number, plural, one {# хвилина} few {# хвилини} other {# хвилин}} тому",
  "relative_time.full.seconds": "{number, plural, one {# секунда} few {# секунди} other {# секунд}} тому",
  "relative_time.hours": "{number}г",
  "relative_time.just_now": "щойно",
  "relative_time.minutes": "{number}х",
  "relative_time.seconds": "{number}с",
  "relative_time.today": "сьогодні",
  "remove_quote_hint.button_label": "Зрозуміло",
  "remove_quote_hint.message": "Це можна зробити за допомогою {icon} меню параметрів.",
  "remove_quote_hint.title": "Хочете вилучити допис із цитати?",
  "reply_indicator.attachments": "{count, plural, one {# вкладення} few {# вкладення} many {# вкладень} other {# вкладення}}",
  "reply_indicator.cancel": "Скасувати",
  "reply_indicator.poll": "Опитування",
  "report.block": "Заблокувати",
  "report.block_explanation": "Ви не будете бачити дописи цього користувача, а вони не зможуть бачити ваші дописи або підписуватися на вас. Вони будуть бачити, що ви їх заблокували.",
  "report.categories.legal": "Правові положення",
  "report.categories.other": "Інше",
  "report.categories.spam": "Спам",
  "report.categories.violation": "Контент порушує одне або кілька правил сервера",
  "report.category.subtitle": "Оберіть найкращий збіг",
  "report.close": "Готово",
  "report.comment.title": "Чи є щось, що нам потрібно знати?",
  "report.forward": "Надіслати до {target}",
  "report.forward_hint": "Це обліковий запис з іншого сервера. Відправити анонімізовану копію скарги й туди?",
  "report.mute": "Приховати",
  "report.mute_explanation": "Ви не побачите їхніх дописів. Вони все ще можуть стежити за вами, бачити ваші дописи, але не знатимуть що їх приховано.",
  "report.next": "Далі",
  "report.placeholder": "Додаткові коментарі",
  "report.reasons.dislike": "Мені це не подобається",
  "report.reasons.dislike_description": "Вам би не хотілося це бачити",
  "report.reasons.legal": "Це незаконно",
  "report.reasons.legal_description": "Ви вважаєте, що це порушує закон вашої чи країни, де розміщено сервер",
  "report.reasons.other": "Це щось інше",
  "report.reasons.other_description": "Ця проблема не відповідає жодній іншій категорії",
  "report.reasons.spam": "Це спам",
  "report.reasons.spam_description": "Шкідливі посилання, фальшиві взаємодії, або повідомлення, що повторюються",
  "report.reasons.violation": "Порушує правила сервера",
  "report.reasons.violation_description": "Ви впевнені, що це порушує певні правила",
  "report.rules.subtitle": "Виберіть усі варіанти, що підходять",
  "report.rules.title": "Які правила порушено?",
  "report.statuses.subtitle": "Виберіть усі варіанти, що підходять",
  "report.statuses.title": "Чи є дописи, які належать до цієї скарги?",
  "report.submit": "Відправити",
  "report.target": "Скаржимося на {target}",
  "report.thanks.take_action": "Ось ваші варіанти керування тим, що ви бачите в Mastodon:",
  "report.thanks.take_action_actionable": "Поки ми переглядаємо це, ви можете вжити власних заходів проти @{name}:",
  "report.thanks.title": "Не хочете це бачити?",
  "report.thanks.title_actionable": "Дякуємо за скаргу, ми розглянемо її.",
  "report.unfollow": "Відписатися від @{name}",
  "report.unfollow_explanation": "Ви підписані на цього користувача. Щоб більше не бачити їхні дописи у вашій стрічці, відпишіться від них.",
  "report_notification.attached_statuses": "{count, plural, one {{count} допис} few {{count} дописи} many {{count} дописів} other {{count} дописи}} прикріплено",
  "report_notification.categories.legal": "Правові",
  "report_notification.categories.legal_sentence": "незаконний контент",
  "report_notification.categories.other": "Інше",
  "report_notification.categories.other_sentence": "інше",
  "report_notification.categories.spam": "Спам",
  "report_notification.categories.spam_sentence": "спам",
  "report_notification.categories.violation": "Порушення правил",
  "report_notification.categories.violation_sentence": "порушення правил",
  "report_notification.open": "Відкрити скаргу",
  "search.clear": "Очистити пошук",
  "search.no_recent_searches": "Немає останніх пошуків",
  "search.placeholder": "Пошук",
  "search.quick_action.account_search": "Збіг профілів {x}",
  "search.quick_action.go_to_account": "Перейти до профілю {x}",
  "search.quick_action.go_to_hashtag": "Перейти до хештегу {x}",
  "search.quick_action.open_url": "Відкрити URL-адресу в Mastodon",
  "search.quick_action.status_search": "Збіг дописів {x}",
  "search.search_or_paste": "Введіть адресу або пошуковий запит",
  "search_popout.full_text_search_disabled_message": "Недоступно на {domain}.",
  "search_popout.full_text_search_logged_out_message": "Доступно лише після входу.",
  "search_popout.language_code": "Код мови ISO",
  "search_popout.options": "Опції пошуку",
  "search_popout.quick_actions": "Швидкі дії",
  "search_popout.recent": "Нещодавні запити",
  "search_popout.specific_date": "конкретна дата",
  "search_popout.user": "користувач",
  "search_results.accounts": "Профілі",
  "search_results.all": "Усі",
  "search_results.hashtags": "Хештеґи",
  "search_results.no_results": "Жодних результатів.",
  "search_results.no_search_yet": "Спробуйте пошукати дописи, профілі або хештеґи.",
  "search_results.see_all": "Показати все",
  "search_results.statuses": "Дописи",
  "search_results.title": "Пошук «{q}»",
  "server_banner.about_active_users": "Люди, які використовують цей сервер протягом останніх 30 днів (Щомісячні Активні Користувачі)",
  "server_banner.active_users": "активні користувачі",
  "server_banner.administered_by": "Адміністратор:",
  "server_banner.is_one_of_many": "{domain} - один з багатьох незалежних серверів Mastodon, які ви можете використати, щоб брати участь у федіверсі.",
  "server_banner.server_stats": "Статистика сервера:",
  "sign_in_banner.create_account": "Створити обліковий запис",
  "sign_in_banner.follow_anyone": "Слідкуйте за ким завгодно у всьому fediverse і дивіться все це в хронологічному порядку. Немає алгоритмів, реклами чи клікбейту.",
  "sign_in_banner.mastodon_is": "Mastodon — найкращий спосіб бути в курсі подій.",
  "sign_in_banner.sign_in": "Увійти",
  "sign_in_banner.sso_redirect": "Увійдіть або зареєструйтесь",
  "status.admin_account": "Відкрити інтерфейс модерації для @{name}",
  "status.admin_domain": "Відкрити інтерфейс модерації для {domain}",
  "status.admin_status": "Відкрити цей допис в інтерфейсі модерації",
  "status.all_disabled": "Поширення й цитування вимкнено",
  "status.block": "Заблокувати @{name}",
  "status.bookmark": "Додати до закладок",
  "status.cancel_reblog_private": "Скасувати поширення",
  "status.cannot_quote": "Вам не дозволено цитувати цей допис",
  "status.cannot_reblog": "Цей допис не може бути поширений",
  "status.contains_quote": "Містить цитату",
  "status.context.loading": "Завантаження відповідей",
  "status.context.loading_error": "Не вдалося завантажити нові відповіді",
  "status.context.loading_success": "Нові відповіді завантажено",
  "status.context.more_replies_found": "Знайдено більше відповідей",
  "status.context.retry": "Повторити",
  "status.context.show": "Показати",
  "status.continued_thread": "Продовження у потоці",
  "status.copy": "Копіювати посилання на допис",
  "status.delete": "Видалити",
  "status.delete.success": "Допис видалено",
  "status.detailed_status": "Детальний вигляд бесіди",
  "status.direct": "Особиста згадка @{name}",
  "status.direct_indicator": "Особиста згадка",
  "status.edit": "Редагувати",
  "status.edited": "Востаннє змінено {date}",
  "status.edited_x_times": "Відредаговано {count, plural, one {{count} раз} few {{count} рази} many {{counter} разів} other {{counter} разів}}",
  "status.embed": "Отримати код вставки",
  "status.favourite": "Уподобане",
  "status.favourites_count": "{count, plural, one {{counter} вподобання} few {{counter} вподобання} many {{counter} вподобань} other {{counter} вподобання}}",
  "status.filter": "Фільтрувати цей допис",
  "status.history.created": "{name} створює {date}",
  "status.history.edited": "{name} змінює {date}",
  "status.load_more": "Завантажити більше",
  "status.media.open": "Натисніть, щоб відкрити",
  "status.media.show": "Натисніть, щоб показати",
  "status.media_hidden": "Медіа приховано",
  "status.mention": "Згадати @{name}",
  "status.more": "Більше",
  "status.mute": "Приховати @{name}",
  "status.mute_conversation": "Ігнорувати розмову",
  "status.open": "Розгорнути допис",
  "status.pin": "Закріпити у профілі",
  "status.quote": "Цитувати",
  "status.quote.cancel": "Скасувати цитування",
  "status.quote_error.blocked_account_hint.title": "Допис сховано, бо ви блокуєте @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Допис сховано, бо ви блокуєте {domain}.",
  "status.quote_error.filtered": "Приховано через один з ваших фільтрів",
  "status.quote_error.limited_account_hint.action": "Усе одно показати",
  "status.quote_error.limited_account_hint.title": "Обліковий запис сховали модератори {domain}.",
  "status.quote_error.muted_account_hint.title": "Допис сховано, бо ви приховуєте @{name}.",
  "status.quote_error.not_available": "Допис недоступний",
  "status.quote_error.pending_approval": "Цитати ще не схвалено",
  "status.quote_error.pending_approval_popout.body": "Mastodon дає вам змогу контролювати, чи можна вас цитувати. Допис буде показано, коли автор схвалить його цитування.",
  "status.quote_error.revoked": "Автор допису не дозволив його цитувати",
  "status.quote_followers_only": "Цитувати можна лише підписникам",
  "status.quote_manual_review": "Автор матиме схвалити вручну",
  "status.quote_noun": "Цитата",
  "status.quote_policy_change": "Змінити, кому можна цитувати",
  "status.quote_post_author": "Цитований допис @{name}",
  "status.quote_private": "Приватних повідомлень цитувати не можна",
  "status.quotes.empty": "Допису ще не цитували. Цитати буде показано тут.",
  "status.quotes.local_other_disclaimer": "Відхилених автором цитат показано не буде.",
  "status.quotes.remote_other_disclaimer": "Цитати за межами {domain} показуються не завжди. Відхилених автором цитат показано не буде.",
  "status.quotes_count": "{count, plural, one {{counter} цитата} few {{counter} цитати} many {{counter} цитат} other {{counter} цитати}}",
  "status.read_more": "Дізнатися більше",
  "status.reblog": "Поширити",
  "status.reblog_or_quote": "Поширити чи цитувати",
  "status.reblog_private": "Поширити підписникам ще раз",
  "status.reblogged_by": "{name} поширює",
  "status.reblogs.empty": "Ніхто ще не поширив цей допис. Коли хтось це зроблять, вони будуть зображені тут.",
  "status.reblogs_count": "{count, plural, one {{counter} поширення} few {{counter} поширення} many {{counter} поширень} other {{counter} поширення}}",
  "status.redraft": "Видалити та виправити",
  "status.remove_bookmark": "Видалити закладку",
  "status.remove_favourite": "Вилучити з улюбленого",
  "status.remove_quote": "Вилучити",
  "status.replied_in_thread": "Відповідь у потоці",
  "status.replied_to": "Відповідь для {name}",
  "status.reply": "Відповісти",
  "status.replyAll": "Відповісти на ланцюжок",
  "status.report": "Поскаржитися на @{name}",
  "status.request_quote": "Попросити дозвіл цитувати",
  "status.revoke_quote": "Видалити мою публікацію з допису @{name}",
  "status.sensitive_warning": "Делікатний вміст",
  "status.share": "Поділитися",
  "status.show_less_all": "Згорнути всі",
  "status.show_more_all": "Розгорнути всі",
  "status.show_original": "Показати оригінал",
  "status.title.with_attachments": "{user} розміщує {{attachmentCount, plural, one {вкладення} few {{attachmentCount} вкладення} many {{attachmentCount} вкладень} other {{attachmentCount} вкладень}}",
  "status.translate": "Перекласти",
  "status.translated_from_with": "Перекладено з {lang} за допомогою {provider}",
  "status.uncached_media_warning": "Попередній перегляд недоступний",
  "status.unmute_conversation": "Не ігнорувати розмову",
  "status.unpin": "Відкріпити від профілю",
  "subscribed_languages.lead": "Лише дописи вибраними мовами з'являтимуться на вашій домівці та у списку стрічок після змін. Виберіть «none», щоб отримувати повідомлення всіма мовами.",
  "subscribed_languages.save": "Зберегти зміни",
  "subscribed_languages.target": "Змінити підписані мови для {target}",
  "tabs_bar.home": "Головна",
  "tabs_bar.menu": "Меню",
  "tabs_bar.notifications": "Сповіщення",
  "tabs_bar.publish": "Новий допис",
  "tabs_bar.search": "Пошук",
  "tag.remove": "Вилучити",
  "terms_of_service.effective_as_of": "Ефективний на {date}",
  "terms_of_service.title": "Умови використання",
  "terms_of_service.upcoming_changes_on": "Майбутні зміни {date}",
  "time_remaining.days": "{number, plural, one {# день} few {# дні} other {# днів}}",
  "time_remaining.hours": "{number, plural, one {# година} few {# години} other {# годин}}",
  "time_remaining.minutes": "{number, plural, one {# хвилина} few {# хвилини} other {# хвилин}}",
  "time_remaining.moments": "Залишилось секунд",
  "time_remaining.seconds": "{number, plural, one {# секунда} few {# секунди} other {# секунд}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} особа} few {{counter} особи} other {{counter} осіб}} {days, plural, one {за останній {days} день} few {за останні {days} дні} other {за останні {days} днів}}",
  "trends.trending_now": "Популярне зараз",
  "ui.beforeunload": "Вашу чернетку буде втрачено, якщо ви покинете Mastodon.",
  "units.short.billion": "{count} млрд",
  "units.short.million": "{count} млн",
  "units.short.thousand": "{count} тис",
  "upload_area.title": "Перетягніть сюди, щоб завантажити",
  "upload_button.label": "Додати зображення, відео або аудіо",
  "upload_error.limit": "Ви перевищили ліміт завантаження файлів.",
  "upload_error.poll": "Не можна завантажувати файли до опитувань.",
  "upload_error.quote": "Додавати файли й цитувати одночасно не можна.",
  "upload_form.drag_and_drop.instructions": "Щоб вибрати медіавкладення, натисніть пробіл або Enter. Під час перетягування, використайте клавіші зі стрілками для переміщення вкладення в будь-якому напрямку. Натисніть пробіл або Enter знову, щоб залишити медіавкладення в новому положенні, або натисніть клавішу Escape, щоб скасувати.",
  "upload_form.drag_and_drop.on_drag_cancel": "Перетягування скасовано. Медіавкладення {item} прибрано.",
  "upload_form.drag_and_drop.on_drag_end": "Медіавкладення {item} прибрано.",
  "upload_form.drag_and_drop.on_drag_over": "Медіавкладення {item} переміщено.",
  "upload_form.drag_and_drop.on_drag_start": "Медіавкладення {item} вибрано.",
  "upload_form.edit": "Змінити",
  "upload_progress.label": "Вивантаження...",
  "upload_progress.processing": "Обробка…",
  "username.taken": "Це ім'я користувача вже зайнято. Спробуйте інше",
  "video.close": "Закрити відео",
  "video.download": "Завантажити файл",
  "video.exit_fullscreen": "Вийти з повноекранного режиму",
  "video.expand": "Розгорнути відео",
  "video.fullscreen": "На весь екран",
  "video.hide": "Приховати відео",
  "video.mute": "Вимкнути звук",
  "video.pause": "Призупинити",
  "video.play": "Програвати",
  "video.skip_backward": "Перемотати назад",
  "video.skip_forward": "Перемотати вперед",
  "video.unmute": "Увімкнути звук",
  "video.volume_down": "Тихіше",
  "video.volume_up": "Гучніше",
  "visibility_modal.button_title": "Налаштувати видимість",
  "visibility_modal.direct_quote_warning.text": "При збереженні поточних налаштувань цитату буде замінено на посилання.",
  "visibility_modal.direct_quote_warning.title": "Цитат не можна вкладати в особисті згадки",
  "visibility_modal.header": "Видимість і взаємодія",
  "visibility_modal.helper.direct_quoting": "Mastodon не дозволяє цитувати особисті згадки.",
  "visibility_modal.helper.privacy_editing": "Видимість не може бути змінена після публікації повідомлення.",
  "visibility_modal.helper.privacy_private_self_quote": "Цитати власних приватних повідомлень не можна робити публічними.",
  "visibility_modal.helper.private_quoting": "Mastodon не дозволяє цитувати дописи, адресовані лише підписникам.",
  "visibility_modal.helper.unlisted_quoting": "Цитати вашого допису також буде сховано зі стрічок трендів.",
  "visibility_modal.instructions": "Налаштуйте, кому можна взаємодіяти з цим дописом. Для майбутніх дописів це можна налаштувати, відкривши <link>Налаштування > Усталені налаштування дописів</link>.",
  "visibility_modal.privacy_label": "Видимість",
  "visibility_modal.quote_followers": "Тільки для підписників",
  "visibility_modal.quote_label": "Кому можна цитувати",
  "visibility_modal.quote_nobody": "Лише мені",
  "visibility_modal.quote_public": "Будь-хто",
  "visibility_modal.save": "Зберегти"
}
